import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { remindersApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';

const Unsubscribe = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [status, setStatus] = useState(token ? 'loading' : 'invalid');

    useEffect(() => {
        if (!token) return;
        remindersApi.unsubscribe(token)
            .then(() => setStatus('done'))
            .catch(() => setStatus('error'));
    }, [token]);

    const copy = {
        loading: { title: 'Unsubscribing…', description: 'One moment.' },
        done: { title: "You're unsubscribed", description: "You won't get any more practice reminder emails. You can turn them back on any time in Settings." },
        error: { title: 'Something went wrong', description: "We couldn't process that link. You can turn reminders off in Settings instead." },
        invalid: { title: 'Invalid link', description: 'This unsubscribe link is missing or malformed.' },
    }[status];

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <CardTitle>{copy.title}</CardTitle>
                    <CardDescription>{copy.description}</CardDescription>
                </CardHeader>
                {status !== 'loading' && (
                    <CardContent>
                        <Button className="w-full rounded-full bg-primary hover:bg-primary/90" onClick={() => navigate('/')}>
                            Back to Mimique
                        </Button>
                    </CardContent>
                )}
            </Card>
        </div>
    );
};

export default Unsubscribe;
